import {
	GET_CONTACT,
	LOAD_CONTACT,
	RESET_CONTACTS,
	GET_SEGMENTS,
	SAVE_SEGMENTS,
} from "../constants/Contacts";

const initState = {
	loading: false,
	contacts: [],
	segments: []
};

const contacts = (state = initState, action) => {
	switch (action.type) {
		case GET_CONTACT:
			return {
				...state,
				loading: true,
			};
		case RESET_CONTACTS:
			return {
				loading: false,
				contacts: [],
				segments: []
			};
		case LOAD_CONTACT:
			return {
				...state,
				contacts: action.payload,
				loading: false,
			};
		case SAVE_SEGMENTS:
			return {
				...state,
				segments: [...action.payload],
				loading: false
			}
		case GET_SEGMENTS:
			return {
				...state,
				loading: true
			}
		default:
			return state;
	}
};

export default contacts;
